import { useEffect, useRef, useState } from 'react';

export const useActiveHeading = (prefix: string, nonce: any) => {
    const observer = useRef<IntersectionObserver>();
    const [activeId, setActiveId] = useState<IntersectionObserverEntry>(null!);

    useEffect(() => {
        const handleObsever: IntersectionObserverCallback = entries => {
            const closest = entries.sort((a, b) => (a.intersectionRatio > b.intersectionRatio ? -1 : 1))[0];
            setActiveId(closest!);
        };
        const headings = ['h1', 'h2', 'h3'];
        const elements = document.querySelectorAll(headings.map(heading => `${prefix} ${heading}`).join(', '));

        observer.current = new IntersectionObserver(handleObsever, {
            threshold: 1,
            rootMargin: '0px 0px -70% 0px',
        });

        elements.forEach(elem => observer.current?.observe(elem));
        return () => observer.current?.disconnect();
    }, [nonce, prefix]);

    return { activeId: activeId?.target?.id };
};
